import { atom } from "jotai";
import { atomWithDefault } from "jotai/utils";

export const aiPromptAtom = atom("");
aiPromptAtom.debugLabel = "aiPromptAtom";

/* When you click "Start over", we want the prompt to be blank.
 * But when you click cancel to close the AI modal, we want the previous prompt
 * to show up again when you click "Modify prompt".
 * */
export const aiPromptAtomResettable = atomWithDefault((get) =>
  get(aiPromptAtom),
);
aiPromptAtomResettable.debugLabel = "aiPromptAtomResettable";
